import React from "react";
import { MessageCircle } from "lucide-react";
import { whatsappHref } from "../lib/site";

export default function WhatsAppButton() {
  return (
    <a
      href={whatsappHref}
      onClick={() => {
         if (typeof window.gtag === "function") {
             window.gtag("event", "whatsapp_click", {
             event_category: "lead",
             event_label: "floating_whatsapp_button",
             page_path: window.location.pathname,
      });
    }
  }}
  target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-24 right-6 md:right-8 z-50 bg-[#25D366] text-white w-14 h-14 md:w-16 md:h-16 rounded-full shadow-2xl flex items-center justify-center hover:scale-110 transition-transform duration-300"
    >
      <MessageCircle size={26} strokeWidth={1.8} />
      <span className="sr-only">WhatsApp</span>
      <span className="absolute -top-1 -right-1 flex h-3 w-3">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-75"></span>
        <span className="relative inline-flex rounded-full h-3 w-3 bg-[#25D366] border-2 border-white"></span>
      </span>
    </a>
  );
}
